<template>
  <v-app>
    <v-container>
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header">Cs Evaluation Supplier Selection
                List</v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-row class="py-2">
                  <v-col md="4" cols="12">
                    <v-text-field v-model="search" append-inner-icon="mdi-magnify" label="Search" single-line
                      hide-details density="compact" variant="outlined" bg-color="grey-lighten-4" class="pl-2"
                      clearable></v-text-field>
                  </v-col>

                  <v-col md="5" cols="12">
                    <div class="d-flex align-center flex-column">
                      <v-btn-group variant="outlined" density="compact" size="x-small" divided>
                        <v-btn prepend-icon="mdi mdi-download" variant="flat" color="success"
                          @click="exportToCSV">CSV</v-btn>
                        <v-btn prepend-icon="mdi mdi-download" variant="flat" color="primary"
                          @click="exportToExcel">EXCEL</v-btn>
                        <v-btn prepend-icon="mdi mdi-download" variant="flat" color="red"
                          @click="exportToPDF">PDF</v-btn>
                      </v-btn-group>
                    </div>
                  </v-col>

                  <v-col md="3" cols="12">
                    <div class="text-right pr-2">
                      <v-btn v-if="$insertAccess($route.fullPath)" @click="goTo('/purchase/add-eval-param-generate')"
                        color="primary" variant="tonal" prepend-icon="mdi mdi-plus" rounded="xl">
                        Create New
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
                <v-data-table :headers="headers" :items="getSchema" :loading="loading"
                  v-model:items-per-page="itemsPerPage" :search="search" :hover="true" density="compact" show-expand
                  item-key="id" class="elevation-1">
                  <template v-slot:item.index="{ index }">
                    {{ ++index }}
                  </template>

                  <template v-slot:item.approved_ind="{ item }">
                    <v-chip v-if="item.approved_ind == 1" color="success" size="small"
                      class="text-capitalize">Yes</v-chip>
                    <v-chip v-else color="red" size="small" class="text-capitalize">No</v-chip>
                  </template>

                  <template v-slot:item.approval_status_display="{ item }">
                    <v-chip
                      v-if="item.approval_current_process && item.approval_current_process.status === 'Pending'"
                      color="yellow-darken-3"
                      size="small"
                    >
                      Wating for {{ item.approval_current_process.approval_step_name.name }}
                    </v-chip>

                    <v-chip
                      v-else-if="item.approval_current_process && item.approval_current_process.status === 'Approved'"
                      color="green"
                      size="small"
                    >
                      Approved By {{ item.approval_current_process.approval_step_name.name }}
                    </v-chip>
                    <v-chip
                      v-else-if="item.approval_current_process && item.approval_current_process.status === 'Cancelled'"
                      color="red"
                      size="small"
                    >
                      Cancelled By  {{ item.approval_current_process.approval_step_name.name }}
                    </v-chip>
                    <v-chip
                      v-else
                      color="green"
                      size="small"
                    >
                      {{ item.approval_status }}
                    </v-chip>
                  </template>

                  <template v-slot:item.actions="{ item }">


            

                    <!-- <v-icon class="me-2 edit-button" color="primary" @click="editItem(item)"
                      v-if="$updateAccess($route.fullPath)">
                      mdi mdi-pencil-outline
                    </v-icon> -->
                  </template>
                  <template v-slot:expanded-row="{ item, columns }">
                    <tr>
                      <td :colspan="columns.length">
                        <v-card flat class="ma-2 pa-2 rounded" color="grey-lighten-4">
                          <div class="text-subtitle-2 text-center text-decoration-underline mb-2">
                            Cs Evaluation Supplier Selection Details
                          </div>
                          <v-data-table :headers="detailHeaders" :items="item.evaluation_result_detail"
                            density="compact" class="elevation-1 pa-2 rounded" hide-default-footer>
                            <!-- Sl -->
                            <template v-slot:item.sl="{ item }">
                              {{ item.id }}
                            </template>

                            <!-- Designation -->
                            <template v-slot:item.supplier="{ item }">
                              {{ item.supplier?.supplier_name }}
                            </template>

                            <template v-slot:item.score="{ item }">
                              {{ item.total_score }}
                            </template>

                            <!-- Final Step -->
                          </v-data-table>
                        </v-card>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import purchaseApprovalStatus from "@/utils/purchaseApprovalStatus";

export default {
  components: {},
  data: () => ({
    itemsPerPage: 10,
    panel: [0],
    loading: false,
    search: "",
    dialog: false,
    data: {},
    purchaseApprovalStatus,
    headers: [
      { title: "#SL", align: "center", key: "index", width: "7%", sortable: false },
      { title: "Code", align: "center", key: "code", sortable: false },
      { title: "Evaluation Date", align: "center", key: "evaluation_date", sortable: false },
      { title: "Selected", align: "center", key: "selected_supplier.supplier_name", sortable: false },
      { title: "Remarks", key: "remarks", align: "center  ", sortable: false },
      { title: "Approval Status", align: "center", key: "approval_status_display", sortable: true },
     
    ],
    detailHeaders: [
      { title: "SL", align: "center", key: "sl", width: "7%" },
      { title: "Supplier", align: "center", key: "supplier" },
      { title: "Ranked", align: "center", key: "rank" },
      { title: "Score ", align: "center", key: "total_score" },
    ],
  }),
  watch: {},
  created() {
    // if (this.$store.getters.getSelectedSupplierList.length == 0) {
      this.$store.dispatch("getSelectedSupplierList");
    // }
  },
  computed: {
    getSchema() {
      return this.$store.getters.getSelectedSupplierList || [];
    },
  },
  setup() { },
  methods: {
    goTo(val) {
      this.$router.push({ path: val }).catch((err) => { });
    },
    purchaseOrder(item) {
      // Use query param so target page can read via this.$route.query.id
      // (push with params requires the route path to have a dynamic segment like /add-purchase/:id)
      this.$router.push({
        name: "add-purchase",
        params: { id: item.rfq_master.requisition_master_id },
      });

      console.log(item.rfq_master.requisition_master_id);
    },


    exportToPDF() {
      let serialNumber = 1;
      const columns = ["#SL", "Code", "Evaluation Date", "Selected", "Remarks"];
      const rows = this.getSchema.map((item) => [
        serialNumber++,
        item.code,
        item.evaluation_date,
        item.selected_supplier.supplier_name,
        item.remarks,
      ]);
      this.$exportTableToPDF(
        columns,
        rows,
        "Selected Supplier List",
        "selected_supplier_list" + this.$fileDate(),
        "landscape"
      );
    },
    exportToExcel() {
      var data = [["#SL", "Code", "Evaluation Date", "Selected", "Remarks"]];
      var serialNumber = 1;
      this.getSchema.forEach((item) => {
        data.push([
          serialNumber++,
          item.code,
          item.evaluation_date,
          item.selected_supplier.supplier_name,
          item.remarks,
        ]);
      });
      this.$exportTableToExcel(
        data,
        "selected_supplier_list" + this.$fileDate()
      );
    },
    exportToCSV() {
      var data = [["#SL", "Code", "Evaluation Date", "Selected", "Remarks"]];
      var serialNumber = 1;
      this.getSchema.forEach((item) => {
        data.push([
          serialNumber++,
          item.code,
          item.evaluation_date,
          item.selected_supplier.supplier_name,
          item.remarks,
        ]);
      });
      this.$exportTableToCSV(data, "selected_supplier_list" + this.$fileDate());
    },
  },
};
</script>
